import React, { useState, useEffect } from "react";
import axios from "axios";

const StudentAttendance = () => {
  const [teacherClassIncharge, setTeacherClassIncharge] = useState("");
  const [assignedClass, setAssignedClass] = useState("");
  const [assignedSection, setAssignedSection] = useState("");
  const [students, setStudents] = useState([]);
  const [attendance, setAttendance] = useState([]);
  const [message, setMessage] = useState("");

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] focus:ring-2 focus:ring-blue-500";

useEffect(() => {
  const fetchTeacherInfo = async () => {
    try {
      const teacherRaw = localStorage.getItem("teacher");
      const sessionId = localStorage.getItem("currentSessionId");

      if (!teacherRaw || !sessionId) {
        setMessage("Missing teacher or session information.");
        return;
      }

      const teacherData = JSON.parse(teacherRaw);
      const teacherId = teacherData.id;

      if (!teacherId) {
        setMessage("Teacher ID not found.");
        return;
      }

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } }
      );

      const teacher = res.data;

      if (teacher.classIncharge) {
        // Split by " - " instead of " ("
        const parts = teacher.classIncharge.split(" - ");
        setAssignedClass(parts[0] || ""); // e.g., "1st"
        setAssignedSection(parts[1] || ""); // e.g., "A"
        setTeacherClassIncharge(teacher.classIncharge);
      } else {
        setMessage("You are not in charge of any class.");
      }
    } catch (err) {
      console.error("Error fetching teacher info:", err.response?.data || err.message);
      setMessage("Error fetching teacher information.");
    }
  };

  fetchTeacherInfo();
}, []);




  useEffect(() => {
    if (assignedClass && assignedSection) {
      const fetchStudents = async () => {
        try {
          const sessionId = localStorage.getItem("currentSessionId");
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents`,
            { params: { sessionId } }
          );

          const filtered = res.data.filter(
            (s) =>
              s.status === "active" &&
              s.class === assignedClass &&
              s.section === assignedSection
          );

          setStudents(filtered);

          setAttendance(
            filtered.map((s) => ({
              rollNo: s.rollNo,
              studentId: s._id,
              date: new Date().toISOString().split("T")[0],
              status: "Present",
              remark: "",
            }))
          );
        } catch {
          setMessage("Error fetching students.");
        }
      };

      fetchStudents();
    }
  }, [assignedClass, assignedSection]);

  const handleChange = (index, e) => {
    const list = [...attendance];
    list[index][e.target.name] = e.target.value;
    setAttendance(list);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate before sending
  if (!assignedClass || !assignedSection) {
    setMessage("Class or Section is missing. Cannot submit attendance.");
    return;
  }

  if (attendance.length === 0) {
    setMessage("No students to submit attendance for.");
    return;
  }

  const sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) {
    setMessage("Session ID missing. Cannot submit attendance.");
    return;
  }

  // Construct payload
  const data = {
    className: assignedClass,
    sectionName: assignedSection,
    students: attendance.map((a) => ({
      studentId: a.studentId,
      rollNo: a.rollNo,
      date: a.date,
      status: a.status,
      remark: a.remark || "",
    })),
    sessionId,
  };

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/attendance/createOrUpdateAttendance`,
      data
    );

    setMessage(
      `Attendance submitted for ${assignedClass} (${assignedSection}) successfully.`
    );

    // Optionally reset attendance
    setAttendance(attendance.map((a) => ({ ...a, status: "Present", remark: "" })));
  } catch (err) {
    console.error("Error submitting attendance:", err.response?.data || err.message);
    setMessage("Error submitting attendance. Please try again.");
  }
};


  if (message) {
    return (
      <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg text-center text-blue-700 !text-[18px] font-semibold">
        {message}
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <i className="fas fa-clipboard-check text-blue-600 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Student Attendance</h1>
        </div>
      </div>

      {/* Class Info */}
      <p className="text-gray-700 mb-4 text-[15px] font-medium">
        Class Incharge:{" "}
        <span className="font-semibold text-blue-600">
          {teacherClassIncharge}
        </span>
      </p>

      {/* Attendance Table */}
      <form onSubmit={handleSubmit} className="space-y-6">
        {students.length > 0 ? (
          <div className="bg-white shadow-md rounded-lg p-4 border border-gray-200 overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-center !text-[14px]">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  {["#", "Roll No", "Student Name", "Status", "Remark"].map(
                    (head) => (
                      <th
                        key={head}
                        className="border px-4 py-2 font-semibold whitespace-nowrap"
                      >
                        {head}
                      </th>
                    )
                  )}
                </tr>
              </thead>

              <tbody>
                {students.map((s, i) => (
                  <tr
                    key={s._id}
                    className="hover:bg-gray-50 transition border-b"
                  >
                    <td className="border px-4 py-2">{i + 1}</td>
                    <td className="border px-4 py-2">{s.rollNo}</td>
                    <td className="border px-4 py-2">
                      {s.firstName} {s.lastName}
                    </td>

                    {/* Status */}
                    <td className="border px-4 py-2">
                      <select
                        name="status"
                        value={attendance[i].status}
                        onChange={(e) => handleChange(i, e)}
                        className={`${inputStyle}`}
                      >
                        <option value="Present">Present</option>
                        <option value="Absent">Absent</option>
                        <option value="onLeave">On Leave</option>
                        <option value="Late">Late</option>
                      </select>
                    </td>

                    {/* Remark */}
                    <td className="border px-4 py-2">
                      <input
                        type="text"
                        name="remark"
                        value={attendance[i].remark}
                        onChange={(e) => handleChange(i, e)}
                        placeholder="Enter remark"
                        className={`${inputStyle} w-full`}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center text-gray-500 !text-[14px] py-6">
            No students found for {assignedClass} ({assignedSection})
          </div>
        )}

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg !text-[14px] w-full"
        >
          Submit Attendance
        </button>
      </form>
    </div>
  );
};

export default StudentAttendance;
